module.exports = __webpack_public_path__ + "fonts/Chivo-BlackItalic.ecf46c8.ttf";